<script>
import Vue from 'vue'

import axios from 'axios'
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
 import {
  required
} from 'vuelidate/lib/validators' 

/**
 * Dashboard-1 Component
 */
export default {
  components: { Layout, PageHeader },
  page: {
    title: 'Propiedad',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  data() {
    return { 
      id:null,    
      title: 'Propiedad',
      form: {
        idMetadato:null,
        descripcion: '',
        tipoId:'',
        idLista:'',
        descripcionTipo: '', 
        lista: []          
      },
      items: [
        {
          text: 'REPODECAM',
          href: '/',
        },
        {
          text: 'Propiedad',
          href: '/metadatos/metadatos',
        },
        {
          text: 'Editar',
          active: true,
        },
      ],
       submitted: false,
    }
  },
  validations: {
    form: {
      descripcion: { required },
      
    },
},
  computed:{
  
  },
  mounted(){
    this.getMetadato(this.$route.params.idMetadato);
    this.cargarListado();

  },
   methods:{

    getMetadato(id){

        axios
            .get(appConfig.recursosApi.metadato + "/" + id )
            .then((response) => {
                this.form = response.data
            })
             .catch(()=>  {
  
                this.$router.push('/500') ;
            });
    },   
    handleSubmit(e) {
      this.submitted = true
       
      if(!this.$v.$invalid){

        return axios
            .put(appConfig.recursosApi.metadato , 
            {idMetadato: this.form.idMetadato, 
             descripcion: this.form.descripcion, 
             tipoId:this.form.tipoId,
            })
            .then((response) => {
               this.$router.push('/metadatos/metadatos/true') ;
            }).catch(()=>  {
               Vue.swal({
        type: 'error',
        title: 'Oops...',
        text: 'Ocurrio un error al intentar guardar los datos.',
        confirmButtonClass: 'btn btn-confirm mt-2',
        
      })
            });

      }
      this.$v.$touch()
    },

      cargarListado(){
       axios
            .get(appConfig.recursosApi.lista)
            .then((response) => {
                this.form.lista = response.data                
            })
             .catch(()=>  {
               // Si ocurre algun error al cargar el listado mandamos un error 500 a la vista.
                this.$router.push('/500') ;
            }); 
     }
   }
}
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
 <div class="row">
      <div class="col-lg-6">
        <div class="card-box">
          <h4 class="header-title m-t-0">Nueva propiedad</h4>
          <p
            class="text-muted font-14 m-b-20"
          >Ingrese la información la propiedad que desea actualizar.</p>

          <form @submit.prevent="handleSubmit">
            <div class="form-group">
              <label for="name">
                Propiedad
                <span class="text-danger">*</span>
              </label>
              <input
                id="descripcion"
                v-model="form.descripcion"
                name="descripcion"
                class="form-control"
                :class="{ 'is-invalid': submitted && $v.form.descripcion.$error }"
                type="text"
                placeholder=""
              />
              <div
                v-if="submitted && !$v.form.descripcion.required"
                class="invalid-feedback"
              >Debe ingresar la descricion de la propiedad que desea actualizar.</div>
            </div>
            <div class="form-group">
              <label>
                Tipo propiedad
                <span class="text-danger">*</span>
              </label>

              <select v-model="form.tipoId"
                type="text"
                name="tipoId"
                class="custom-select"
                :class="{ 'is-invalid': submitted && $v.form.tipoId.$error }"
                placeholder="">
              
                  <option value="6">Fecha</option>
                  <option value="7">Texto</option>
                  <option value="8">Lista</option>
              </select>
              
              <div v-show="form.tipoId === '8'">
                <br/>
                <label>Lista: </label>

                <select  v-model="form.idLista" name="IdLista" class="custom-select" >
                   <option v-for="listaOpcion in form.lista" :key="listaOpcion.idLista" :value="listaOpcion.idLista">
                            {{ listaOpcion.nombre }}
                     </option>
                </select>
              </div>
              
              <div v-if="submitted && $v.form.descripcionTipo.$error" class="invalid-feedback">
                <span v-if="!$v.form.direccion.required">El campo es obligatorio.</span>
              </div>
            </div>
          
            <div class="form-group text-right m-b-0">
              <button class="btn btn-primary" type="submit">Guardar</button>
              <router-link class="btn btn-secondary m-l-5 ml-1" to="/metadatos/metadatos"> Cancelar</router-link>
            </div>
          </form>
        </div>
        <!-- end card-box -->
      </div>
 </div>
  </Layout>
</template>